import React, { useContext } from 'react';
import { Button, Icon, Menu } from 'semantic-ui-react';
import useScroll from '../../../../../foundation/hooks/use-scroll';
import { NavigationContext } from '../../Navigation.context';
import './Toggle.css';
var defaultProps = {
  iconName: 'bars',
  content: ''
};
export default function Toggle(_ref) {
  var iconName = _ref.iconName,
    content = _ref.content;
  var _useScroll = useScroll(),
    hideTabBar = _useScroll.hideTabBar;
  var _useContext = useContext(NavigationContext),
    toggled = _useContext.toggled,
    setToggled = _useContext.setToggled;
  function handleToggle() {
    hideTabBar(); // hides mobile tab so it does not interferes with navigation
    setToggled(function (previousState) {
      return !previousState;
    });
  }
  return /*#__PURE__*/React.createElement(Menu.Item, {
    className: "toggle-item"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleToggle,
    "aria-label": "Open navigation bar",
    icon: true
  }, content, /*#__PURE__*/React.createElement(Icon, {
    name: toggled ? 'close' : iconName,
    size: "large"
  })));
}
Toggle.defaultProps = defaultProps;